module.exports = __webpack_public_path__ + "img/36-config-usuarios-edit.992203a9.png";